import * as yup from "yup";

export const AddressSchema = yup.object({
  addr_name: yup.string().required("배송지 이름을 입력해주세요."),
  zipcode: yup.string().required("우편번호를 입력해주세요."),
  doro_addr: yup.string().required("도로명 주소를 입력해주세요."),
  base_addr: yup.string().required("지번 주소를 입력해주세요."),
  detail_addr: yup.string().required("상세 주소를 입력해주세요."),
});
